import * as types from '../mutation-types'

const moduleCatalogo = {
	state: {
		catalogo: {},
		statusCatalogo: {},
		fpagamento: [],
	},
	getters: {
		catalogo: state => { return state.catalogo },
		statusCatalogo: state => { return state.statusCatalogo },
		fpagamento: state => { return state.fpagamento },
	},
	mutations: {
		[types.ADD_CATALOGO](state, catalogo) { state.catalogo = catalogo },
		[types.ADD_STATUSCATALOGO](state, statusCatalogo) { state.statusCatalogo = statusCatalogo },
		[types.ADD_FPAGAMENTO](state, fpagamento) { state.fpagamento = fpagamento },
	},
	actions: {
		addCatalogo({ commit }, catalogo) {
			commit(types.ADD_CATALOGO, catalogo)
		},
		addStatusCatalogo({ commit }, statusCatalogo) {
			commit(types.ADD_STATUSCATALOGO, statusCatalogo)
		},
		addFpagamento({ commit }, fpagamento) {
			commit(types.ADD_FPAGAMENTO, fpagamento)
		}
	},
}
export default moduleCatalogo